<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="time-off-v3.policyComponents.workSchedules.overallSettings.edit.header"
        [back]="true"
    ></app-header>

    <form #form="ngForm">
        <app-overall-settings-update-card [workSchedule]="workSchedule"></app-overall-settings-update-card>
    </form>

    <div class="buttons flex flex-end">
        <ui-button type="ghost" (click)="onCancel()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSave()">{{ 'save' | translate }}</ui-button>
    </div>
</div>
